import { render, staticRenderFns } from "./Italy.vue?vue&type=template&id=0a6d46f1&scoped=true&"
import script from "./Italy.vue?vue&type=script&lang=js&"
export * from "./Italy.vue?vue&type=script&lang=js&"
import style0 from "./Italy.vue?vue&type=style&index=0&id=0a6d46f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6d46f1",
  null
  
)

export default component.exports